import instance from "@/utils/require.js"

// 维修单--分页查询
export function apiAipcRepairSearch(data = {}) {
	return instance({
		url: "/aim/api/v3/aipc_repair/search",
		method: "post",
		data
	})
}

//维修记录--导出
export function apiAipcRepairRecordExport(data = {}) {
	return instance({
		url: "/aim/api/v3/aipc_repair/export",
		method: "post",
		data
	})
}

//维修记录--退回送修前
export function apiAipcRepairRollback(data = {}) {
	return instance({
		url: "/aim/api/v3/aipc_repair/rollback",
		method: "post",
		data
	})
}